import { render, staticRenderFns } from "./collapseItem.vue?vue&type=template&id=4db99d4c&scoped=true"
import script from "./collapseItem.vue?vue&type=script&lang=js"
export * from "./collapseItem.vue?vue&type=script&lang=js"
import style0 from "./collapseItem.vue?vue&type=style&index=0&id=4db99d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db99d4c",
  null
  
)

export default component.exports